module.exports = __webpack_public_path__ + "assets/reserved-port.7224ea76.svg";